import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/operator/catch';
import { type ActionsObservable, type Epic, combineEpics } from 'redux-observable';
import log from '@atlassian/jira-servicedesk-automation-common/src/log';
import type { State } from '../state/types';
import summaryLoadEpic from './get';
import ruleEpic from './rule';
import saveRunAsUserEpic from './run-as-user/save';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type StateEpic = Epic<any, State>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	combineEpics(
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		summaryLoadEpic as StateEpic,
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		ruleEpic as StateEpic,
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		saveRunAsUserEpic as StateEpic,
	)(action$, store).catch((error, stream) => {
		log.safeErrorWithoutCustomerData('servicedesk.automation.summary.ops', 'Unhandled error');
		return stream;
	});
